import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import GoogleAnalytics from 'react-ga';

import TopBar from './service-list/TopBar';

import { fetchGetRoutes } from '../actions/GetRoutesAction';

import { THEME } from '../configs/global';

import downloadIcon from '../assets/images/download-circle.svg';

import moment from 'moment';

let gkey = THEME.GA.KEY ? THEME.GA.KEY : 'UA-126901899-1';
if (window.location.hostname === 'coachtracker.nationalexpress.com')
  gkey = 'UA-22502992-7';

GoogleAnalytics.initialize(gkey);

const mapStateToProps = (state) => ({
  isMobileScreen: state.mobileScreen,
  routes: state.routes,
});

class RouteList extends Component {
  state = {
    filterValue: undefined,
  };

  componentDidMount() {
    this.props.fetchGetRoutes(
    );
  }


  navigateTo = (e) => {
    e.preventDefault();

    const { isMobileScreen, history, match } = this.props;

    if (isMobileScreen.open && isMobileScreen.detailView) {
      if (match.params.reference)
        history.push(`/view/reference/${match.params.reference}`);
      else if (match.params.stop)
        history.push(`/view/stop/${match.params.stop}`);
      else if (match.params.service)
        history.push(`/view/service/${match.params.service}`);
      else if (match.params.to)
        history.push(`/view/between/${match.params.from}/${match.params.to}`);
      else history.push(`/`);

      return undefined;
    }

    history.push('/');
  };


  render() {

    const {
      routes,
      history,
    } = this.props;

    if (typeof window.__sharethis__ !== 'undefined') {
      window.__sharethis__.href = window.location.href;
    }
    return (
      <Fragment>
          <div className="main__results">
            <TopBar title="Search again" onClick={this.navigateTo} />

            <TopBar
              title="Search again"
              className="navlink--back"
              onClick={this.navigateTo}
            />

            <div className="results">
              <div className='routes__container'>
                <ol>
                  {(routes.length || routes.alphabetical_routes) && routes.alphabetical_routes.map((route) =>
                    <li key={route.route_id}>
                      <div onClick={() => {history.push(`/view/service/${route.route_id}`)}}>
                        <span className='service'>{route.short_name}</span>
                        {route.departure_location_name} <span className='arrow'>-></span> {route.arrival_location_name}
                      </div>
                      {THEME.ROUTES_PDF_LINK &&
                        <a href={`${THEME.ROUTES_PDF_LINK}/?origin=${route.departure_location_name}&dest=${route.arrival_location_name}&privateCode=${route.route_id}&departDate=${moment().format('YYYY-MM-DD')}`} target="_blank" rel="noreferrer">
                          <img src={downloadIcon} alt="toward" />
                        </a>
                      }
                    </li>
                  )}
                </ol>
              </div>
            </div>
          </div>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, {
  fetchGetRoutes,
})(RouteList);



// WEBPACK FOOTER //
// ./src/containers/RouteList.js